import {
    defaultBadgeFormSettings,
    defaultBadgeSampleAccountData,
    getDataForImageGenerationBaseImpl,
} from '@/backend/features/badging/badging-configuration/shared';
import { RmsBadgeData } from '@/backend/features/badging/shared';
import { ExtendedAccountData } from '@/backend/features/contact-management/entities/extended-account/types';
import { sampleImageGenerationBarcodeData } from '@juvare/badging/backend/features/badges/shared/sampleImageGenerationBarcodeData';
import { GetTemplateDataForBadgeClassifierImageGeneration } from '@juvare/badging/backend/features/badges/types/GetTemplateDataForBadgeClassifierImageGeneration';
import { sampleAamvaObject } from '@juvare/badging/backend/features/barcodesAamvaBadge/shared';
import { sampleAnsiHeader } from '@juvare/badging/backend/features/barcodesAamvaBadge/shared/sampleAamvaData';
import { BadgeTemplateRenderData } from '@juvare/badging/backend/types';
import { addMonths } from 'date-fns';
import { Base64 } from 'js-base64';

/**
 * Generate final data to render Badge Template
 */

export const getTemplateDataForBadgeClassifierImageGeneration: GetTemplateDataForBadgeClassifierImageGeneration<ExtendedAccountData> = (
    badgeTemplateClassifier,
    data,
) => {
    const currentDate = new Date();
    const formSettings = data.formSettings ?? defaultBadgeFormSettings;
    const expirationIntervalMonths = formSettings.defaultExpirationInterval;
    const barcode: BadgeTemplateRenderData['barcode'] = {
        ansiHeader: sampleAnsiHeader,
        aamvaData: sampleAamvaObject,
        barcodeHorizontalSvg: sampleImageGenerationBarcodeData.barcodeHorizontalSvg,
        barcodeHorizontalSvgBase64: Base64.encode(sampleImageGenerationBarcodeData.barcodeHorizontalSvg),
        barcodeVerticalSvg: sampleImageGenerationBarcodeData.barcodeVerticalSvg,
        barcodeVerticalSvgBase64: Base64.encode(sampleImageGenerationBarcodeData.barcodeVerticalSvg),
    };

    return Promise.resolve({
        ...getDataForImageGenerationBaseImpl({
            badge: {
                name: 'Sample Badge',
                formSettings,
                templateSnapshot: badgeTemplateClassifier as RmsBadgeData['templateSnapshot'],
                expirationIntervalMonths,
            },
            account: data.account ?? defaultBadgeSampleAccountData.data,
            accountBadge: {
                accountBadgeNumericId: 0,
                accountBadgeNumber: '0',
                accountId: '',
                badgeId: '',
                issuedAt: currentDate.getTime(),
                expiresAt: addMonths(currentDate, expirationIntervalMonths).getTime(),
                status: 'valid',
                distributionStatus: 'not-printed',
                options: {},
            },
            isExample: true,
        }),
        barcode,
    });
};
